/**
 * Quote Queue
 *
 * Left panel showing list of quotes with user's pending work.
 * Sorted by: quotes with my work first, then by due date.
 */

import QuoteCard from "./QuoteCard";

export default function QuoteQueue({
  quotes,
  selectedQuote,
  onSelectQuote,
  selectedWorkCenters,
}) {
  if (quotes.length === 0) {
    return (
      <div className="p-4 text-gray-500 text-sm">
        No projects found
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200/50">
      {quotes.map((quote) => (
        <QuoteCard
          key={quote.quoteNumber}
          quote={quote}
          isSelected={selectedQuote?.quoteNumber === quote.quoteNumber}
          onSelect={() => onSelectQuote(quote)}
          selectedWorkCenters={selectedWorkCenters}
        />
      ))}
    </div>
  );
}
